import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../auth.service';

@Component({
  selector: 'mesc-administration',
  templateUrl: './administration.component.html',
  host: { 'class': 'router-outlet' },
  // styleUrls: ['./administration.component.scss'],
})
export class MescAdministrationComponent implements OnInit {

  constructor(
    public router: Router,
    private authService: AuthenticationService
  ) { }

  ngOnInit() { }

  validatePath(path: string): boolean {
    return this.authService.isClaimValid(path);
  }
}
